import { GetStorage } from "../../data/protocols/cache";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
} from "../../data/protocols/http";
import { AccessDeniedError } from "../../domain/errors";

export class AuthorizeHttpClientDecorator implements HttpClient {
  constructor(
    private readonly getStorage: GetStorage,
    private readonly httpClient: HttpClient
  ) {}

  async request(data: HttpRequest): Promise<HttpResponse> {
    try {
      const account = this.getStorage.get("account");
      if (account?.accessToken) {
        Object.assign(data, {
          headers: Object.assign(data.headers || {}, {
            "x-access-token": account.accessToken,
          }),
        });
      }
      const httpResponse = await this.httpClient.request({
        ...data,
        withCreadentials: true,
      });
      return httpResponse;
    } catch (error) {
      throw new AccessDeniedError();
    }
  }
}
